// extracted by mini-css-extract-plugin
export default {"wrapper":"fvYJ2HFllc4SioLSeqNq","showHistoryBtn":"N6LyRHNhHwWitwx3CNhm","showHistoryBtnIcon":"rTBJ53nsIQIVx82NL5ID"};